/**
 * Created by rlopez on 08/11/16.
 */

import $ from 'jquery';

import RestService from 'RestService.js';
import NotificationService from 'NotificationService.js';

import constants    from 'Constants.js';

const ICON_CONNECTION = constants.DB_ICON_CONNECTION;
const ICON_EMPTY = constants.DB_ICON_EMPTY;
import zLib             from 'util/ZLib.js';
import sequenceService  from 'SequenceService.js';
import ActionXMLService from 'ActionXMLService';
import ActionService from '../views/dashboard/connections/action-type/ActionService';
import undoService from 'UndoService';
import ConnectionService from '../views/dashboard/connections/ConnectionService';
import textConstants        from 'TextConstants';
import listService from 'ListService.js';
import eventBus from 'EventBus';
import util from 'util/Util.js';
import restMessages from 'RestMessages';

//==========================================================================================
// This singleton controller wraps the connection API
//==========================================================================================
class ConnectionDashboardController{

    constructor() {

    }

    createNew(mainView, connectionType){
        let connectionId; 

        this.persistNewConnection(mainView, connectionType).then(connection => {
            let undoButton = $('#dashboardUndo');
            let redoButton = $('#dashboardRedo'); 

            if(connection){
                connectionId = connection.ConnectionId;
                undoService.add({
                    undo: () => {
                        ConnectionService.                      
                            makeDeleteConnection(connectionId, connectionType, false);
                    },
                    redo: () => {
                        this.undeleteConnection(mainView, connectionId, connectionType);
                    }
                }, textConstants.UNDO_NEW_CONNECTION);

                util.setUndoRedoAccess();
            }
        });
    }

    undeleteConnection(mainView, connectionId, connectionType) {
        return RestService.undeleteConnection(connectionId).then((data)=>{
            if (listService.activeDashboardTab === constants.DASHBOARD_SECTION_CONNECTIONS) {
                this.expandUpdatedConnectionListAndDetailView(mainView, connectionId,connectionType);
            }
            
        }).catch((err)=> {
            console.log('Error Creating New Connection', err);
            NotificationService.error(`Error Creating New Connection. ${err.MESSAGE}`);
        });
    }

    redoDeleteConnection (connectionId, connectionType) {
        RestService.deleteConnection(connectionId).then((response) => {
            eventBus.trigger(constants.EV_DELETE_CONNECTION, connectionType);
        })
        .catch((err)=> {
            console.log('Error Deleting Connection', err);
            notificationService.error(`Error Deleting Connection. ${err.MESSAGE}`);
        });
    }

    redoDeleteAction (actionId, connectionId, actionType) {
        RestService.deleteAction(actionId, connectionId).then(response => {            
            eventBus.trigger(constants.EV_DELETE_ACTION, connectionId, actionType);
        }).catch( err => {
            console.log('Error Deleting Action', err);
            notificationService.error(`Error Deleting Action. ${err.MESSAGE}`);
        });
    }

    persistNewConnection(mainView, connectionType){
        return RestService.addConnection(connectionType).then((data)=>{
            console.log("Add New Connection Response",data);
            this.expandUpdatedConnectionListAndDetailView(mainView,data.RESULT.RESPONSE.ConnectionId,connectionType);
            return data.RESULT.RESPONSE;
        }).catch((err)=> {
            console.log('Error Creating New Connection', err);
            NotificationService.error(err);
        });
    }

    createAction(mainView,connectionId, connectionType){
        mainView.killDetailView();

        const actionXML = this.getActionXMLTemplate(connectionId, connectionType);

        this.persistNewAction(connectionId, actionXML.type, actionXML.xml, mainView).then(data => {
            if (data){
                let newActionID = data.ActionId;
                undoService.add({
                    undo: () => {
                        this.deleteAction(newActionID, connectionId, connectionType);
                    },
                    redo: () => {
                        this.undeleteAction(connectionId, newActionID, connectionType, mainView);
                    }
                }, textConstants.UNDO_NEW_ACTION);

                util.setUndoRedoAccess();
            }
        });
    }

    deleteAction(actionID, connectionId, connectionType){
        ActionService.makeDeleteAction(actionID, connectionId, connectionType, false);
    }

    undeleteAction(connectionId, actionId, connectionType, mainView){
        return RestService.undeleteAction(connectionId, actionId).then((data)=>{

            if (listService.activeDashboardTab === constants.DASHBOARD_SECTION_CONNECTIONS) {
                this.expandUpdatedActionListAndDetailView(mainView, actionId, connectionId, connectionType);
            }
        }).catch((err)=> {
            console.log('Error Creating New Action', err);
            NotificationService.error(`Error Creating New Action. ${err.MESSAGE}`);
        });
    }

    persistNewAction(connectionId, connectionType, actionXML, mainView){
        return RestService.addAction(connectionId, connectionType, actionXML).then((data)=>{
            console.log("Action Added",data);
            this.expandUpdatedActionListAndDetailView(mainView,data.RESULT.RESPONSE.ActionId,connectionId,connectionType);
            return data.RESULT.RESPONSE;
        }).catch((err)=> {
            let errMsg = restMessages.codeToMessage(err.CODE);
            console.log(errMsg + '. ' + err);
            NotificationService.error('Error Creating New Action. ' + errMsg);
        });
    }

    getActionXMLTemplate(connectionId, connectionType){
        const template = ActionXMLService.getTemplate(connectionType, connectionId);
        template.xml = zLib.compressForm(template.xml);
        return template;
    }

    expandUpdatedConnectionListAndDetailView(mainView,connectionId,connectionType){
        RestService.getConnections(constants.DEFAULT_GROUP_ID,connectionType,constants.CONNECTIONS_DEFAULT_PURPOSE).then((data)=>{
            console.log("Connections Browse",data);
            console.log("Connection Type", connectionType);
            console.log("Connection Id", connectionId);
            
            let connectionContainer = $("div").find(`[data-itemid='${connectionType}']`).data().target;           
            this.renderConnectionItems(mainView,data,connectionType,connectionContainer);
            if(connectionId) {
                $('li[role="button"]').removeClass('bg-success');
                $(`i[data-itemid*="${connectionId}"]`).parent('li').addClass('bg-success');
                mainView.renderConnectionDetails(connectionId,connectionType);
            }
            else{
                mainView.cleanDetailView();
            }

        }).catch((err)=> {
            console.log('Error Retrieving updated connection list items', err);
            NotificationService.error(`Error Retrieving updated connection list items. ${err.MESSAGE}`);
        });
    }

    expandUpdatedActionListAndDetailView(mainView,actionId,connectionId,actionType){

        let connectionType = actionType.slice(0,-1);
        connectionType = connectionType === '8' ? '9' : connectionType;
        RestService.getConnections(constants.DEFAULT_GROUP_ID,connectionType,constants.CONNECTIONS_DEFAULT_PURPOSE).then((data)=> {
            console.log("Connections Browse", data);
            let connectionContainer;
            switch (connectionType) {
                case constants.DATABASES_GROUP_TYPE:
                    connectionContainer = constants.CONNECTION_DATABASES_CONTAINER;break;
                case constants.DIRECTORY_GROUP_TYPE:
                    connectionContainer = constants.CONNECTION_DIRECTORY_CONTAINER;break;
                case constants.WEB_GROUP_TYPE:
                    connectionContainer = constants.CONNECTION_WEB_CONTAINER;break;
                case constants.REST_GROUP_TYPE:
                    connectionContainer = constants.CONNECTION_REST_CONTAINER;break;
                case constants.FORMS_GROUP_TYPE:
                    connectionContainer = constants.CONNECTION_FORMS_CONTAINER;break;
                case constants.GOOGLE_GROUP_TYPE_DETAIL_VIEW:
                case constants.GOOGLE_GROUP_TYPE:
                    connectionContainer = constants.CONNECTION_GOOGLE_CONTAINER;break;
                case constants.TEXT_GROUP_TYPE:
                    connectionContainer = constants.CONNECTION_TEXT_CONTAINER;break;
                case constants.VECTORDB_GROUP_TYPE:
                    connectionContainer = constants.CONNECTION_VECTORDB_CONTAINER;break;
            }

            this.renderConnectionItems(mainView, data, connectionType, connectionContainer);
            RestService.getActionsByConnectionId(connectionId, constants.SETTINGS_CONNECTIONS_FORM_ID, constants.SETTINGS_CONNECTIONS_PURPOSE).then((data) => {
                console.log("Actions Browse", data);
                let actionContainer = $(`i[data-itemid*='${connectionId}']`).attr('data-target');

                this.renderActionItems(mainView, data, connectionType, connectionId, actionContainer);
                if (actionId) {
                    let iElement = $(`i[data-itemid*="${connectionId}"]`);
                    iElement.first().toggleClass('pf-carot-left pf-carot-down');
                    $('li[role="button"]').removeClass('bg-success');
                    $(`i[data-itemid*="${actionId}"]`).parent('li').addClass('bg-success');
                    $($(`i[data-itemid*="${connectionId}"]`).attr('data-target')).collapse('show');
                    mainView.renderActionDetails(actionId, connectionId);
                }
                else {
                    $('li[role="button"]').removeClass('bg-success');
                    $($(`i[data-itemid*="${connectionId}"]`).attr('data-target')).collapse('show');
                    mainView.cleanDetailView();
                }

            }).catch((err) => {
                console.log('Error Retrieving updated action list items', err);
                NotificationService.error(`Error Retrieving updated action list items. ${err.MESSAGE}`);
            });
        }).catch((err)=> {
            console.log('Error Retrieving updated action list items', err);
            NotificationService.error(`Error Retrieving updated action list items. ${err.MESSAGE}`);
        });
    }
//
    renderConnectionItems(mainView,data,groupType,dataTarget){
        console.log("Custom List Data",data);
        let nodes = [],sectionInModel,viewFormsSectionModel;
        if ((data && data.length > 0) || (data && !$.isEmptyObject(data))) {
            let connections = data instanceof Array ? data : [data];
                 nodes = this.loadConnectionsFromResponse(connections,groupType);
        }
        else{
            nodes = [{
                nodeName: 'no items',
                url: '#',
                icon: ICON_EMPTY,
                id: 0,
                groupType: groupType,
                nodeType: '',
                hasChildren: false
            }]
        }
        switch(groupType){
            case constants.DATABASES_GROUP_TYPE:sectionInModel='Databases';viewFormsSectionModel=mainView.model.get('connectionSections').sections[0];break;
            case constants.DIRECTORY_GROUP_TYPE:sectionInModel='Directory Services';viewFormsSectionModel=mainView.model.get('connectionSections').sections[1];break;
            case constants.WEB_GROUP_TYPE:sectionInModel='SOAP Web Services';viewFormsSectionModel=mainView.model.get('connectionSections').sections[2];break;
            case constants.REST_GROUP_TYPE:sectionInModel='REST Web Services';viewFormsSectionModel=mainView.model.get('connectionSections').sections[6];break;
            case constants.FORMS_GROUP_TYPE:sectionInModel='Forms';viewFormsSectionModel=mainView.model.get('connectionSections').sections[3];break;
            case constants.GOOGLE_GROUP_TYPE:case constants.GOOGLE_GROUP_TYPE_DETAIL_VIEW:sectionInModel='Google Spreadsheets';viewFormsSectionModel=mainView.model.get('connectionSections').sections[4];break;
            case constants.TEXT_GROUP_TYPE:sectionInModel='Text File';viewFormsSectionModel=mainView.model.get('connectionSections').sections[5];break;
            case constants.VECTORDB_GROUP_TYPE:sectionInModel='Vector Databases';viewFormsSectionModel=mainView.model.get('connectionSections').sections[7];break;
        }
            nodes.forEach((node)=>{
                if(node.hasChildren){
                    viewFormsSectionModel.groups.push(node);
                }
                else{
                    viewFormsSectionModel.nodes.push(node);
                }
            });
            let group={
                nodes:nodes
            };
            mainView.addItemsToSection(group, dataTarget);
            //this.selectedNodeOnTree = group.id;
            //this.selectedNodeTarget = dataTarget;
       // mainView.addItemsToGroup(group, dataTarget);
    }

    renderActionItems(mainView,data,connectionType,connectionId,actionContainer){
        let actions = data;
        console.log('Actions',actions);
        let nodes = [];
        if (actions && actions.length > 0) {
            nodes = this.loadActionsFromResponse(actions, connectionType,connectionId);
        } else {
            nodes = [{
                nodeName: 'no items',
                url: '#',
                icon: ICON_EMPTY,
                id: 0,
                groupType: 0,
                nodeType: '',
                hasChildren: false
            }]
        }


        // Rendering the nodes under connection section.
        let viewFormsSectionModel=mainView.model.get('connectionSections').sections[1];
        nodes.forEach((node)=>{
            if(node.hasChildren){
                viewFormsSectionModel.groups.push(node);
            }
            else{
                viewFormsSectionModel.nodes.push(node);
            }
        });
        let group={
            nodes:nodes
        };
        mainView.addItemsToSection(group, actionContainer);
    }

    loadConnectionsFromResponse(connections, nodeType) {
        let nodes = [],
        itemNodeType = '',
        groupResponseType='';

        switch (nodeType) {
            case constants.DATABASES_GROUP_TYPE:
                itemNodeType = 'databases';
                groupResponseType = itemNodeType;
                break;
            case constants.DIRECTORY_GROUP_TYPE:
                itemNodeType = 'directory';
                groupResponseType = itemNodeType;
                break;
            case constants.WEB_GROUP_TYPE:
                itemNodeType = 'web';
                groupResponseType = itemNodeType;
                break;
            case constants.REST_GROUP_TYPE:
                itemNodeType = 'rest';
                groupResponseType = itemNodeType;
                break;
            case constants.FORMS_GROUP_TYPE:
                itemNodeType = 'forms';
                groupResponseType = itemNodeType;
                break;
            case constants.GOOGLE_GROUP_TYPE:
                itemNodeType = 'google';
                groupResponseType = itemNodeType;
                break;
            case constants.TEXT_GROUP_TYPE:
                itemNodeType = 'text';
                groupResponseType = itemNodeType;
                break;
        }

        for(let connection of connections) {
            if (connection['@hasChildren'] === 'True') {
                nodes.push(
                    {
                        nodeName: connection['@Name'],
                        icon: ICON_EMPTY,
                        id: connection['@ConnId'] + '-' + connection['@ConnectionId'],
                        groupType: groupResponseType,//group['@type'] || groupResponseType,
                        nodeType: connection['@Type'],
                        toggleIcon: 'pf-carot-left',
                        hasChildren: connection["@hasChildren"],
                        nodes: []
                    });
            }
            else {
                nodes.push({
                    nodeName: connection['@Name'],
                    url: '#',
                    icon: ICON_EMPTY,
                    id: connection['@ConnId'] + '-' + connection['@ConnectionId'],
                    groupType: groupResponseType,
                    nodeType: connection["@Type"],
                    hasChildren: connection["@hasChildren"],
                    toggleIcon: connection["@hasChildren"] === 'True' ? 'pf-carot-left' : ''
                });
            }
        }

        return nodes;
    }

    loadActionsFromResponse(actions, nodeType,connectionId) {
        let nodes = [],
            itemNodeType = '',
            groupResponseType='';

        switch (nodeType) {
            case constants.DATABASES_GROUP_TYPE:
                itemNodeType = 'databases';
                groupResponseType = itemNodeType;
                break;
            case constants.DIRECTORY_GROUP_TYPE:
                itemNodeType = 'directory';
                groupResponseType = itemNodeType;
                break;
            case constants.WEB_GROUP_TYPE:
                itemNodeType = 'web';
                groupResponseType = itemNodeType;
                break;
            case constants.REST_GROUP_TYPE:
                itemNodeType = 'rest';
                groupResponseType = itemNodeType;
                break;
            case constants.FORMS_GROUP_TYPE:
                itemNodeType = 'forms';
                groupResponseType = itemNodeType;
                break;
            case constants.GOOGLE_GROUP_TYPE:
                itemNodeType = 'google';
                groupResponseType = itemNodeType;
                break;
            case constants.TEXT_GROUP_TYPE:
                itemNodeType = 'text';
                groupResponseType = itemNodeType;
                break;
        }


        for(let action of actions) {
                nodes.push({
                    nodeName: action['@Name'],
                    url: '#',
                    icon: ICON_EMPTY,
                    id: action['@ActionId'] + '-' + connectionId,
                    groupType: groupResponseType,
                    nodeType: action["@Type"],
                    hasChildren: false,
                    toggleIcon: ''
                });
        }

        return nodes;
    }
}

const connectionDashboardController = new ConnectionDashboardController();
export default connectionDashboardController;
